import { NoCostLoginMethod } from '@tob/shared/no-cost-authentication/constants';

/**
 * Customize the sequence of no cost authentication activation prompt
 * Able to customize which login methods are available based on cooldown logic in the future
 */
export function getNoCostAuthenticationActivationPromptSequence() {
  return [NoCostLoginMethod.Biometrics];
}

// return milliseconds
export function getQuickLoginActivationCooldown() {
  return 0;
}

/**
 * @returns Maximum number of no cost authentication activation operations that we will prompt the user to do
 */
export function getMaximumActivationNum(): number | undefined {
  return undefined;
}

// TODO: migrate biometrics custom logic to this file
